import _ from "lodash";

/**
 * Array fields loaded from the API must replace template defaults entirely.
 * lodash merge() merges arrays by index, which injects phantom rows from
 * initialValues (e.g. IA Levy at 0.00 when the DN only has Premium in DB).
 */
export const FORM_ARRAY_FIELDS_REPLACE = [
  "chargeItems",
  "costItems",
  "descriptions",
  "terms",
  "insured",
  "checkList",
  "fileList",
  "files",
  "consultantFiles",
  "particulars",
  "logs",
];

/**
 * Merge form initialValues with server data for edit/load.
 * Scalar/object fields use deep merge; listed array fields use server data when present.
 */
export function mergeFormInitialValues(initialValues, data) {
  const merged = _.merge({}, initialValues, data);
  for (const field of FORM_ARRAY_FIELDS_REPLACE) {
    if (Array.isArray(data?.[field])) {
      merged[field] = data[field];
    }
  }
  return merged;
}
